import api from './api';

// Buscar pipeline de status por entidade
export const getStatusPipeline = async (entityType) => {
  const response = await api.get(`/status-pipeline/${entityType}`);
  return response.data;
};

export default {
  getStatusPipeline
};
